import {
  updateResourceState,
  createResourceReducer,
  RESOURCE,
  RECORD_FIELD
} from '@unicus/react-ui-kit';
import {
  ATTENDANCE,
  ATTENDANCE_CLOSE_DOCUMENT,
  ATTENDANCE_CREATE_DOCUMENT,
  ATTENDANCE_CREATE_DOCUMENT_FIELD,
  ATTENDANCE_CREATE_DOCUMENT_FIELD_FINISHED,
  ATTENDANCE_DELETE_DOCUMENT_FIELD,
  ATTENDANCE_START_OR_STOP_SERVICE,
  ATTENDANCE_START_OR_STOP_SERVICE_FINISHED,
  ATTENDANCE_UPDATE_ANSWER,
  ATTENDANCE_UPDATE_ANSWER_FINISHED,
  ATTENDANCE_UPDATE_DOCUMENT_FIELD,
  ATTENDANCE_UPDATE_DOCUMENT_FIELD_FINISHED,
  ATTENDANCE_SET_EDIT_VALUES,
  ATTENDANCE_CREATE_PRESCRIPTION_FIELD,
  ATTENDANCE_CREATE_PRESCRIPTION_FIELD_FINISHED,
  ATTENDANCE_CLOSE_PRESCRIPTION,
  ATTENDANCE_CREATE_PRESCRIPTION,
  ATTENDANCE_UPDATE_PRESCRIPTION_FIELD,
  ATTENDANCE_UPDATE_PRESCRIPTION_FIELD_FINISHED,
  ATTENDANCE_DELETE_PRESCRIPTION_FIELD,
  ATTENDANCE_PRESCRIPTION_REDIRECT_RECEITA_DIGITAL,
  ATTENDANCE_PRESCRIPTION_REDIRECT_RECEITA_DIGITAL_FINISHED,
  ATTENDANCE_GET_ANALYSIS,
  ATTENDANCE_GET_ANALYSIS_FINISHED
} from './attendanceActions';

const handleError = (state, action) => {
  return updateResourceState(state, action, RESOURCE, () => ({
    startingOrstopping: false,
    creatingPrescription: false,
    creatingDocument: false,
    loading: false,
    saving: false,
    redirecting: false
  }));
};

const attendanceReducer = createResourceReducer(
  ATTENDANCE,
  [],
  {
    [ATTENDANCE_START_OR_STOP_SERVICE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        startingOrstopping: true
      }));
    },

    [ATTENDANCE_START_OR_STOP_SERVICE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          startingOrstopping: false,
          [RECORD_FIELD]: {
            ...action.payload.data.result
          }
        };
      });
    },

    [ATTENDANCE_SET_EDIT_VALUES](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        [RECORD_FIELD]: {
          ...action.payload
        }
      }));
    },

    [ATTENDANCE_UPDATE_ANSWER](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ [RECORD_FIELD]: { sections = [], ...rest } }) => {
          const { id, fields } = action.payload;

          const newSections = sections.map((c) => {
            if (c.id === id) {
              return { ...c, fields };
            }

            return c;
          });

          return {
            saving: true,
            [RECORD_FIELD]: {
              ...rest,
              sections: newSections
            }
          };
        }
      );
    },

    [ATTENDANCE_CREATE_DOCUMENT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        modalDocumentEdit: action.payload
      }));
    },

    [ATTENDANCE_CLOSE_DOCUMENT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        modalDocumentEdit: null
      }));
    },

    [ATTENDANCE_CREATE_DOCUMENT_FIELD](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        creatingDocument: true
      }));
    },

    [ATTENDANCE_CREATE_DOCUMENT_FIELD_FINISHED](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ [RECORD_FIELD]: { sections = [], ...rest } }) => {
          const newSections = [
            ...sections.map((c) => {
              if (
                c.type === 'document' &&
                c.id === action.payload.data.result.sectionId
              ) {
                return {
                  ...c,
                  documents: [action.payload.data.result, ...c.documents]
                };
              }

              return c;
            })
          ];

          return {
            creatingDocument: false,
            modalDocumentEdit: null,
            [RECORD_FIELD]: {
              ...rest,
              sections: [...newSections]
            }
          };
        }
      );
    },

    [ATTENDANCE_UPDATE_DOCUMENT_FIELD](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        creatingDocument: true
      }));
    },

    [ATTENDANCE_UPDATE_DOCUMENT_FIELD_FINISHED](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ [RECORD_FIELD]: { sections = [], ...rest } }) => {
          const newSections = [
            ...sections.map((c) => {
              if (
                c.type === 'document' &&
                c.id === action.payload.data.result.sectionId
              ) {
                return {
                  ...c,
                  documents: c.documents.map((d) => {
                    if (d.id === action.payload.data.result.id) {
                      return action.payload.data.result;
                    }

                    return d;
                  })
                };
              }

              return c;
            })
          ];

          return {
            creatingDocument: false,
            modalDocumentEdit: null,
            [RECORD_FIELD]: {
              ...rest,
              sections: [...newSections]
            }
          };
        }
      );
    },

    [ATTENDANCE_DELETE_DOCUMENT_FIELD](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ [RECORD_FIELD]: { sections = [], ...rest } }) => {
          const newSections = [
            ...sections.map((c) => {
              if (c.type === 'document') {
                return {
                  ...c,
                  documents: c.documents.filter((d) => d.id !== action.payload)
                };
              }

              return c;
            })
          ];

          return {
            [RECORD_FIELD]: {
              ...rest,
              sections: [...newSections]
            }
          };
        }
      );
    },

    [ATTENDANCE_DELETE_PRESCRIPTION_FIELD](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ [RECORD_FIELD]: { sections = [], ...rest } }) => {
          const newSections = [
            ...sections.map((c) => {
              if (c.type === 'prescription') {
                return {
                  ...c,
                  prescriptions: c.prescriptions.filter(
                    (d) => d.id !== action.payload
                  )
                };
              }

              return c;
            })
          ];

          return {
            [RECORD_FIELD]: {
              ...rest,
              sections: [...newSections]
            }
          };
        }
      );
    },

    [ATTENDANCE_UPDATE_ANSWER_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        saving: false
      }));
    },

    [ATTENDANCE_CREATE_PRESCRIPTION_FIELD](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        creatingPrescription: true
      }));
    },

    [ATTENDANCE_CREATE_PRESCRIPTION_FIELD_FINISHED](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ [RECORD_FIELD]: { sections = [], ...rest } }) => {
          const newSections = [
            ...sections.map((c) => {
              if (
                c.type === 'prescription' &&
                c.id === action.payload.data.result.sectionId
              ) {
                return {
                  ...c,
                  prescriptions: [
                    action.payload.data.result,
                    ...c.prescriptions
                  ]
                };
              }

              return c;
            })
          ];

          return {
            creatingPrescription: false,
            modalPrescriptionEdit: null,
            [RECORD_FIELD]: {
              ...rest,
              sections: [...newSections]
            }
          };
        }
      );
    },

    [ATTENDANCE_CLOSE_PRESCRIPTION](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        modalPrescriptionEdit: null
      }));
    },

    [ATTENDANCE_CREATE_PRESCRIPTION](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        modalPrescriptionEdit: action.payload
      }));
    },

    [ATTENDANCE_UPDATE_PRESCRIPTION_FIELD](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        creatingPrescription: true
      }));
    },

    [ATTENDANCE_UPDATE_PRESCRIPTION_FIELD_FINISHED](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ [RECORD_FIELD]: { sections = [], ...rest } }) => {
          const newSections = [
            ...sections.map((c) => {
              if (
                c.type === 'prescription' &&
                c.id === action.payload.data.result.sectionId
              ) {
                return {
                  ...c,
                  prescriptions: c.prescriptions.map((d) => {
                    if (d.id === action.payload.data.result.id) {
                      return action.payload.data.result;
                    }

                    return d;
                  })
                };
              }

              return c;
            })
          ];

          return {
            creatingPrescription: false,
            modalPrescriptionEdit: null,
            [RECORD_FIELD]: {
              ...rest,
              sections: [...newSections]
            }
          };
        }
      );
    },

    [ATTENDANCE_PRESCRIPTION_REDIRECT_RECEITA_DIGITAL](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        redirecting: true
      }));
    },

    [ATTENDANCE_PRESCRIPTION_REDIRECT_RECEITA_DIGITAL_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        redirecting: false
      }));
    },

    [ATTENDANCE_GET_ANALYSIS](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: true
      }));
    },

    [ATTENDANCE_GET_ANALYSIS_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        analysis: action.payload.data.result,
        loading: false
      }));
    }
  },
  handleError
);

export default attendanceReducer;
